import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import { CoachDisclosure } from 'bundles/ai-coach-platform/components/patterns';
import { ExternalCoachAction } from 'bundles/ai-coach-platform/components/patterns/chat/ExternalCoachAction';
import { getCoachSearchQueries } from 'bundles/search-common/components/experiments/coachInSearch/coachSearchQueries';
import {
  coachAdditionalContext,
  coachConfig,
} from 'bundles/search-common/components/experiments/coachInSearch/constants';

import _t from 'i18n!nls/search-common';

type Props = {
  query: string;
  setCoachOpen: (open: boolean) => void;
};

export const SearchCoachDisclosure = ({ query, setCoachOpen }: Props) => {
  const handleClick = () => {
    setCoachOpen(true);
  };

  const lowercasedQuery = query.toLowerCase();
  const coachCaptionAndCtas = getCoachSearchQueries()[lowercasedQuery];
  const coachTriggerButtons = coachCaptionAndCtas?.ctas
    ? coachCaptionAndCtas.ctas.map((cta) => (
        <ExternalCoachAction
          key={cta}
          label={cta}
          message={cta}
          newSessionOnClick={true}
          variant="secondary"
          onClick={handleClick}
          isDisclosureButton={true}
          config={{ ...coachConfig }}
          additionalContext={[{ ...coachAdditionalContext }]}
        />
      ))
    : [];

  return coachCaptionAndCtas ? (
    <CoachDisclosure
      actionButtons={coachTriggerButtons}
      defaultExpanded
      collapsible={false}
      mode={coachConfig.coachModeId}
    >
      <Typography2 component="p">{_t('Need help exploring more learning options?')}</Typography2>
    </CoachDisclosure>
  ) : null;
};
